<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.bulkLockingPaymentContracts') }}
			</div>
			<v-row dense>
				<v-col cols="12">
					<DropdownMultiple
						v-model="paymentContracts"
						:ajax="true"
						:data="'open-payment-contracts'"
						:errorBorder="!paymentContractsValidation"
						:label="'* ' + $t('fields.openPaymentContracts')"
					></DropdownMultiple>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="closeContractsClick">
					{{ $t('buttons.lock') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import DropdownMultiple from '../../trinkets/DropdownMultiple';

export default {
	name: 'BulkLocking',
	components: { DropdownMultiple },
	emits: ['close'],
	data() {
		return {
			paymentContracts: [],
			paymentContractsValidation: true,
		};
	},
	methods: {
		cancelClick() {
			this.paymentContracts = [];
			this.$emit('close');
		},

		closeContractsClick() {
			var vm = this;
			let success = true;

			if (this.paymentContracts.length < 1) {
				success = false;
				this.paymentContractsValidation = false;
			} else {
				this.paymentContractsValidation = true;
			}

			if (success) {
				this.$APICall(
					'post',
					'payment-contracts/bulk-locking',
					{ payment_contracts: this.paymentContracts },
					(_, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.selectedPaymentContractsClosed'));
							vm.$emit('reload');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
						vm.$emit('close');
					}
				);
			}
		},
	},
	mounted() {},
};
</script>
